import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa },
    current: "fa",
    rtl: {
      fa: true,
    },
  },

  rtl: true,
  theme: {
    themes: {
      light: {
        primary: "#3760ac",
        secondary:"#3760ac",
        light:"#3ec6ee",
        whiteColor: "#F2F2F2",
        blackColor: "#707070",
        grayColor: "#ECECEC",
      },
    },
  },
});
